import React from 'react';
import Points from 'components/Points';
import FeatureCardLayout from './FeatureCardLayout';
import './ZeroFeesCard.css';

interface ZeroFeesCardProps {
  isElite: boolean;
}

const ZeroFeesCard: React.FC<ZeroFeesCardProps> = ({ isElite }) => {
  const preview = (
    <div className="zero-fees-card-preview">
      <Points points={0} type="big" />
    </div>
  );

  const cta = (
    <p className="feature-card-aspirational">
      {isElite
        ? 'Your zero-fee rate is locked in for the life of your membership'
        : 'Limited-time offer for founding members'}
    </p>
  );

  return (
    <FeatureCardLayout
      title="Zero Point-Fees, Always"
      description="Elite waives both the monthly maintenance fee and the 1% transaction fee on trades. Sign up during the launch promotion and your zero-fee rate is locked in for the life of your membership."
      previewContent={preview}
      ctaContent={cta}
      className="zero-fees-card"
    />
  );
};

export default ZeroFeesCard;
